module.exports = __webpack_public_path__ + "img/1.b2187b6.webp";